export const renderCustomMarkdownToHtml = (src: string): string => {
  if (!src) return "";
  let text = src.replace(/\r\n?|\n/g, "\n");
  const escapeHtml = (s: string) =>
    s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  text = escapeHtml(text);
  text = text.replace(/^#+\s*/gm, "");
  text = text.replace(/```/g, "");
  text = text.replace(/`/g, "");

  // Remove explicit /cmd tokens
  text = text.replace(/(^|\s)\/cmd\b/g, (m, p1) => p1);

  //Convert *italic* to <em>italic</em>
  text = text.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, (_match, pre, inner) => {
    return `${pre}<em>${inner}</em>`;
  });

  //remove ~~strikethrough~~
  text = text.replace(/~~([^~\n]+)~~/g, (_match, inner) => {
    return inner;
  });

  // Convert newlines to <br/>
  text = text.replace(/\n+/g, "<br/>");

  return text;
};
